import { useEffect, useRef } from 'react'
import { fabric } from 'fabric'

export default function FabricJSCanvas(props) {
  const {
    style,
    onReady,
    initialJson,
    transformInitialJson = json => json,
    backgroundColor
  } = props

  const canvasEl = useRef(null)
  const canvasElParent = useRef(null)

  useEffect(() => {
    const canvas = new fabric.Canvas(canvasEl.current)
    const setCurrentDimensions = () => {
      canvas.setHeight(canvasElParent.current?.clientHeight || 0)
      canvas.setWidth(canvasElParent.current?.clientWidth || 0)
      canvas.renderAll()
    }
    const resizeCanvas = () => {
      setCurrentDimensions()
    }
    setCurrentDimensions()
    
    window.addEventListener('resize', resizeCanvas, false)
    
    if (backgroundColor) {
      canvas.backgroundColor = backgroundColor
    }
    if (initialJson) {
      canvas.loadFromJSON(transformInitialJson(initialJson))
    }
    onReady(canvas)

    return () => {
      canvas.dispose()
      window.removeEventListener('resize', resizeCanvas)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div ref={canvasElParent} style={style}>
      <canvas ref={canvasEl} />
    </div>
  )
}